/* eslint-disable react/forbid-prop-types,react/require-default-props */
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Dimmer, Loader, Table } from "../..";
import TableHeader from "./TableHeader";
import TablePagination from "./TablePagination";
import AdvancedTableRow from "./AdvancedTableRow";
import AdvancedTableColumn from "./AdvancedTableColumn";
import "./AdvancedTable.css";
import { getRest } from "../../utils";

/**
 * Table advanced.
 * Columns sortable, editable
 * Pagination
 * Header
 *
 * @param {*} props
 * @return {*}
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var AdvancedTable = function AdvancedTable(props) {
  var color = props.color,
    header = props.header,
    actions = props.actions,
    actionsRow = props.actionsRow,
    _props$actionsRowLabe = props.actionsRowLabel,
    actionsRowLabel = _props$actionsRowLabe === void 0 ? 'Actions' : _props$actionsRowLabe,
    data = props.data,
    columns = props.columns,
    currentPage = props.currentPage,
    lastPage = props.lastPage,
    loading = props.loading,
    defaultSelectedRow = props.defaultSelectedRow,
    onRowSelect = props.onRowSelect,
    onCellSelect = props.onCellSelect,
    onChange = props.onChange,
    onSort = props.onSort,
    onPageChange = props.onPageChange;
  var _React$useState = React.useState(null),
    selectedRow = _React$useState[0],
    setSelectedRow = _React$useState[1];
  var _React$useState2 = React.useState(null),
    selectedCell = _React$useState2[0],
    setSelectedCell = _React$useState2[1];
  var _React$useState3 = React.useState(),
    valueInput = _React$useState3[0],
    setValueInput = _React$useState3[1];
  var _React$useState4 = React.useState({}),
    sort = _React$useState4[0],
    setSort = _React$useState4[1];

  /**
     * Handle row selection.
     *
     * @param {*} item
     */
  var handleRowSelect = React.useCallback(function (item) {
    setSelectedRow(item == null ? void 0 : item.identifiant);
    if (onRowSelect) {
      onRowSelect(item);
    }
  }, [onRowSelect]);

  // Sélectionne la ligne demandée par défaut
  React.useEffect(function () {
    if (_.isNumber(defaultSelectedRow) && data && data.length > defaultSelectedRow) {
      handleRowSelect(data[defaultSelectedRow]);
    }
  }, [defaultSelectedRow, data, handleRowSelect]);

  /**
     * Handle cell click to transform in input
     *
     * @param {Object} item
     * @param {Object} column
     */
  var handleCellClick = function handleCellClick(item, column) {
    var identifiant = item.identifiant;
    var property = column.property;
    setSelectedRow(identifiant);
    setSelectedCell({
      identifiant: identifiant,
      property: property
    });
    setValueInput(item[property]);
    if (onCellSelect) {
      onCellSelect(item, column);
    }
  };

  /**
     * Reset la cellule sélectionnée
     */
  var handleBlur = React.useCallback(function () {
    setSelectedCell(null);
  }, []);

  /**
     * Gère le tri des colonnes
     */
  var handleSort = React.useCallback(function (property) {
    setSort(function (prev) {
      var newSort;
      if (_.has(prev, property) && prev[property] === 'asc') {
        newSort = _.omit(prev, [property]);
      } else if (_.has(prev, property) && prev[property] === 'desc') {
        var _Object$assign;
        newSort = Object.assign({}, prev, (_Object$assign = {}, _Object$assign[property] = 'asc', _Object$assign));
      } else {
        var _Object$assign2;
        newSort = Object.assign({}, prev, (_Object$assign2 = {}, _Object$assign2[property] = 'desc', _Object$assign2));
      }
      if (onSort) {
        onSort(newSort);
      }
      return newSort;
    });
  }, [onSort]);
  var rest = getRest(AdvancedTable, props);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TableHeader, {
      header: header,
      actions: actions
    }), /*#__PURE__*/_jsxs(Table, Object.assign({
      unstackable: true,
      striped: true,
      sortable: true,
      color: color,
      style: {
        margin: 0
      }
    }, rest, {
      children: [/*#__PURE__*/_jsx(Table.Header, {
        children: /*#__PURE__*/_jsxs(Table.Row, {
          children: [_.map(columns, function (column) {
            return /*#__PURE__*/_jsx(AdvancedTableColumn, {
              column: column,
              sort: sort[column == null ? void 0 : column.property],
              onSort: handleSort
            }, column.property);
          }), _.isFunction(actionsRow) && /*#__PURE__*/_jsx(AdvancedTableColumn, {
            column: {
              text: actionsRowLabel,
              textAlign: 'center'
            }
          })]
        })
      }), /*#__PURE__*/_jsx(Table.Body, {
        children: _.map(data, function (item) {
          return /*#__PURE__*/_jsx(AdvancedTableRow, {
            actionsRow: actionsRow,
            value: valueInput,
            columns: columns,
            item: item,
            selectedCell: selectedCell,
            selectedRow: selectedRow,
            onChange: onChange,
            onRowSelect: onRowSelect,
            onCellClick: handleCellClick,
            onBlur: handleBlur
          }, item.identifiant);
        })
      }), /*#__PURE__*/_jsx(Dimmer, {
        active: loading,
        inverted: true,
        children: /*#__PURE__*/_jsx(Loader, {})
      })]
    })), !_.isNil(currentPage) && /*#__PURE__*/_jsx(TablePagination, {
      currentPage: currentPage,
      lastPage: lastPage,
      onPageChange: onPageChange,
      color: color
    })]
  });
};
AdvancedTable.handledProps = ["actions", "actionsRow", "actionsRowLabel", "color", "columns", "currentPage", "data", "defaultSelectedRow", "header", "lastPage", "loading", "onCellSelect", "onChange", "onPageChange", "onRowSelect", "onSort"];
AdvancedTable.propTypes = {
  /** Header. */
  header: PropTypes.node,
  /** Actions. */
  actions: PropTypes.node,
  /** Actions des lignes. */
  actionsRow: PropTypes.func,
  /**
     * Label pour la colonne des actions
     */
  actionsRowLabel: PropTypes.node,
  /** Data. */
  data: PropTypes.arrayOf(PropTypes.object),
  /** Columns with properties. */
  columns: PropTypes.arrayOf(PropTypes.shape({
    /**
         * Libellé de la colonne
         */
    text: PropTypes.node,
    /**
         * Propriété à utiliser dans les données
         */
    property: PropTypes.string,
    /**
         * La colonne est modifiable.
         */
    editable: PropTypes.bool,
    /**
         * Fonction affichant le composant de modification d'une cellule.
         * Si une modale est retournée, la valeur originale restera affichée.
         *
         * @param item {Object} Element concerné par la modification
         * @param onChange {function} Callback de changement
         * @param onBlur {function} Callback de blur
         */
    editRenderer: PropTypes.func,
    /**
         * Type de l'input de la colonne.
         */
    type: PropTypes.oneOf(['text', 'number', 'date', 'checkbox']),
    /**
         * Largeur de la colonne sur 16
         */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    /**
         * La colonne est triable
         */
    sortable: PropTypes.bool
  })),
  /** Callback row selected. */
  onRowSelect: PropTypes.func,
  /** Callback cell selected. */
  onCellSelect: PropTypes.func,
  /**
     * Callback value changed.
     *
     * @param item {Object} Element concerné pas la modification, inchangé
     * @param property {string} Propriété modifiée
     * @param value {any} Nouvelle valeur
     */
  onChange: PropTypes.func,
  /**
     * Callback column sort.
     *
     * @param cols {Object} Colonnes à triées
     */
  onSort: PropTypes.func,
  /** Callback page changed. */
  onPageChange: PropTypes.func,
  /** Current page. */
  currentPage: PropTypes.number,
  /** Last page. */
  lastPage: PropTypes.number,
  /** Color (domain). */
  color: PropTypes.string,
  /** Data is loading */
  loading: PropTypes.bool,
  /**
     * La ligne à sélectionner par défaut.
     * Appel le callback onRowSelect et sélectionne visuellement la ligne
     */
  defaultSelectedRow: PropTypes.number
};
export default AdvancedTable;